import { IonCard, IonItem, IonImg } from "@ionic/react";
import "./Card.style.css";

interface IAppCardsProps {
  image?: any;
  title: string;
  onClick?: any;
}

export default function ServiceCards(props: IAppCardsProps) {
  return (
    <div>
      <IonCard className={`service-cards`} onClick={props.onClick}>
        <IonItem className={`service-cards-item`}>
          <IonImg
            src={props.image}
            alt={props.title}
            className={`service-cards-image`}
          />
        </IonItem>
        <div className="title-text">
          <h1>{props.title}</h1>
        </div>
      </IonCard>
    </div>
  );
}
